import React from "react";
import { GPUInstanceType } from "components/Environment/Settings/Tabs/Compute/InstanceChanger/GPUTypes";
import {
  CircleStackIcon,
  CloudIcon,
  CpuChipIcon,
} from "@heroicons/react/24/outline";
import { classNames } from "components/utils";
import {
  displayPlatformType,
  formatMemory,
} from "components/Environment/utils";
import { InstanceAttribute } from "components/Environment/Settings/Tabs/Compute/InstanceChanger/InstanceAttribute";
import Chip from "components/Environment/Create/chips";

interface ComputePieceProps {
  instanceType: GPUInstanceType | undefined;
  diskStorage: string;
}

export const ComputePiece: React.FC<ComputePieceProps> = ({
  instanceType,
  diskStorage,
}) => {
  return (
    <div className="flex flex-col h-full items-start">
      <div className="flex flex-row items-center mb-1 text-primary text-sm">
        <CpuChipIcon className="h-6 w-6 mr-1" />
        <span>Compute</span>
      </div>
      {instanceType && (
        <div className="flex flex-row items-center text-primary">
          {instanceType.supported_gpus && (
            <Chip
              selected={true}
              chipName={instanceType.supported_gpus[0].name || ""}
              manufacturerName={
                instanceType.supported_gpus[0].manufacturer || ""
              }
              onClick={() => {}}
              className={classNames("h-[50px] mr-2 flex-shrink-0")}
            />
          )}
          <div>
            <InstanceAttribute
              variant="small"
              instanceType={instanceType.type}
              isGPUInstance={!!instanceType.supported_gpus}
              vcpu={instanceType.vcpu}
              memory={formatMemory(
                instanceType.memory,
                instanceType.workspace_groups[0].platformType
              )}
              gpuManufacturer={
                instanceType.supported_gpus
                  ? instanceType.supported_gpus[0].manufacturer
                  : ""
              }
              gpuName={
                instanceType.supported_gpus
                  ? instanceType.supported_gpus[0].name
                  : ""
              }
              gpuMemory={
                instanceType.supported_gpus
                  ? instanceType.supported_gpus[0].memory
                  : ""
              }
              gpuCount={
                instanceType.supported_gpus
                  ? instanceType.supported_gpus[0].count
                  : 0
              }
            />
            <div className="flex flex-col mt-1">
              <div className="flex flex-row">
                <div className="flex flex-row mb-1 items-center mr-2">
                  <CircleStackIcon className="h-4 w-4 mr-1" />
                  <span className="text-xs">
                    {instanceType.elastic_root_volume
                      ? diskStorage + "GiB"
                      : instanceType.supported_storage
                      ? instanceType.supported_storage[0].size
                      : "120GiB"}
                  </span>
                </div>
                <div className="flex flex-row mb-1 items-center">
                  <CloudIcon className="h-4 w-4 mr-1" />
                  <span className="text-xs">
                    {displayPlatformType(
                      (instanceType.workspace_groups &&
                        instanceType.workspace_groups[0].platformType.toUpperCase()) ||
                        "Unknown"
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
